import React, { useEffect, useState } from 'react';
import { Layout, Popconfirm, message, Button, Table, Space } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import MemberSidebar from './components/member.sidebar.component';
import MemberFooter from './components/member.footer.component';
import { useDispatch } from 'react-redux';
import { readArticleTags, deleteArticleTag } from '../actions/entity.article.tag';
import { PageHeader } from '@ant-design/pro-components';
import { useTranslation } from 'react-i18next';

function ArticleTags(props) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const { Content } = Layout;
    const [dataSource, setDataSource] = useState([]);

    const deleteArticleTagAction = (id) => {
        dispatch(deleteArticleTag(params.entityId, id)).then((response) => {
            message.success(t('entities.message.delete-success'));
            setDataSource(dataSource.filter(item => item.id !== id));
        }).catch(e => {
            console.log(e);
            message.error(t('entities.message.delete-failed'));
        });
    }

    const columns = [
        {
            title: t('entityArticleTags.columns.slug'),
            dataIndex: 'slug',
            key: 'slug',
        },
        {
            title: t('entityArticleTags.columns.status'),
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (typeof record.status !== 'undefined' && record.status === true) {
                    return t('entityArticleTags.columns.status.enabled');
                } else {
                    return t('entityArticleTags.columns.status.disabled');
                }
            }
        },
        {
            title: t('entityArticleTags.columns.created'),
            dataIndex: 'createdAt',
            key: 'createdAt'
        },
        {
            title: t('entityArticleTags.columns.actions'),
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => <Space>
                <Button size="small" type="primary" href={`/entity/${params.entityId}/article-tag/${record.id}`}>{t('entityArticleTags.actions.edit')}</Button>
                <Popconfirm
                    title={t('entityArticleTags.actions.delete-confirm')}
                    onConfirm={() => deleteArticleTagAction(record.id)}
                    okText={t('entityArticleTags.actions.delete-ok')}
                    cancelText={t('entityArticleTags.actions.delete-cancel')}
                >
                    <Button size="small" type="primary" danger>{t('entityArticleTags.actions.delete')}</Button>
                </Popconfirm>
            </Space>

        }
    ];

    useEffect(() => {
        dispatch(readArticleTags(params.entityId)).then((response) => {
            if (typeof response.result !== 'undefined') {
                setDataSource(response.result);
            } else {
                setDataSource([]);
            }
        }).catch((error) => {
            try {
                setDataSource([]);
                let responseMessage = error.response.data.message;
                console.log(responseMessage);
                message.error(responseMessage);
            } catch (e) {
                console.log('Failed:', e);
                message.error(JSON.stringify(e));
            }
        });
    }, [dispatch, params.entityId]);

    return <>
        <MemberSidebar />
        <Layout className="site-layout">
            <Content style={{ margin: '0 16px' }}>
                <div className="site-layout-background">
                    <PageHeader
                        className="site-page-header"
                        onBack={() => navigate(`/entity/${params.entityId}/dashboard`)}
                        title={t('entityArticleTags.title')}
                        subTitle={t('entityArticleTags.subtitle')}
                        extra={[
                            <Button key="create" type="primary" href={`/entity/${params.entityId}/article-tag`}>{t('entityArticleTags.actions.new')}</Button>
                        ]}
                    />
                    <Table
                        size='small'
                        rowKey={record => record.id}
                        dataSource={dataSource}
                        columns={columns} />
                </div>
            </Content>
            <MemberFooter />
        </Layout>
    </>;
}

export default ArticleTags;